// gsap and ScrollTrigger are globals from PHP-enqueued vendor scripts

export function initLetsTalkCounters() {
    const counters = document.querySelectorAll('[data-count]');

    if (counters.length) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);

                const el         = entry.target;
                const raw        = String(el.dataset.count);
                const normalized = raw.replace(/,/g, '');
                const end        = parseFloat(normalized);
                const duration   = 2000;
                const start      = performance.now();
                const decimals   = (normalized.split('.')[1] || '').length;

                function tick(now) {
                    const elapsed  = now - start;
                    const progress = Math.min(elapsed / duration, 1);
                    const eased    = 1 - Math.pow(1 - progress, 3);

                    el.textContent = (eased * end).toLocaleString('en-US', {
                        minimumFractionDigits: decimals,
                        maximumFractionDigits: decimals,
                    });

                    if (progress < 1) requestAnimationFrame(tick);
                }

                requestAnimationFrame(tick);
            });
        }, { threshold: 0.1 });

        counters.forEach(el => observer.observe(el));
    }

    const revealEls = document.querySelectorAll(`
        .block--custom-layout__lets-talk .header_text,
        .block--custom-layout__lets-talk .small_text,
        .block--custom-layout__lets-talk .heading,
        .block--custom-layout__lets-talk .number
    `);

    if (!revealEls.length) return;

    revealEls.forEach((el, i) => {
        gsap.fromTo(el,
            { opacity: 0, y: -30 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                delay: i * 0.1,
                scrollTrigger: {
                    trigger: el,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                },
            }
        );
    });
}
